import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box, TextField, Button, Grid, Container, Paper, Typography, Select, MenuItem, FormControl,
  InputLabel, IconButton, Checkbox, FormControlLabel
} from '@mui/material';
import DataTable from 'react-data-table-component';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { LobService } from '../services/lobService';
import { useNavigate } from 'react-router-dom';
import { resetTabState, setContractsOld } from '../Redux/TabDucks';
import { SearchService } from '../services/SearchService';
import { setCargaDatos } from '../Redux/GeneralDuck';
import { formatToCLP } from '../services/monedaService';//'../services/monedaService';
import moment from 'moment';
import HourglassTopTwoToneIcon from '@mui/icons-material/HourglassTopTwoTone';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';

import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const ContractSearchPage = ({ myAccount }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false); // Estado para el cargando
  const [filteredItems, setFilteredItems] = useState([]); // Datos filtrados para la tabla
  const [myAccountData, setMyAccountData] = useState(null);
  const _GENERAL = useSelector((store) => store.general);

  const [searching, setSearching] = useState(false);

  const [searchCriteria, setSearchCriteria] = useState({
    Desde: null,
    Hasta: null,
    Identifier: null,
    LineNegocio: null,
    Validado: null,
    NoValidado: null,
    Confirmado: null,
    NoConfirmado: null,
    Cancelado: null,
    Finiquitado: null,
    //Estado: ''
  });

  const columns = [
    {
      name: 'Id',
      selector: row => row.customerInterviewId,
    },
    {
      name: 'Código contrato',
      selector: row => (row?.codCtto && String(row.codCtto).trim() !== '' ? row.codCtto : 'ENTREVISTA_EN_CURSO'),
      sortable: true,
      width: "240px",
      cell: row => {
        const label = (row?.codCtto && String(row.codCtto).trim() !== '')
          ? row.codCtto
          : 'ENTREVISTA_EN_CURSO';
        return (
          <Button
            className='p-1'
            style={{ width: "230px" }}
            variant='outlined'
            onClick={() => HandleOpenCtto(row)}
          >
            {label}
          </Button>
        );
      },
    },
    // {
    //     name: 'Negocio',
    //     selector: row => (row.lineOfBusiness ? row.lineOfBusiness.split(' ').slice(1).join(' ') : ''),
    //     sortable: true,
    //     width: "100px",
    // },
    {
      name: 'Rut',
      selector: row => row.identifier,
      sortable: true,
      width: "auto",
      width: "106px",
    },
    {
      name: 'Defendido',
      selector: row => row.name,
      sortable: true,
      width: "190px"//,
    },
    {
      name: 'Firmado',
      selector: row => row.confirmationDate ? new Date(row.confirmationDate) : null,
      format: row => row.confirmationDate ? moment(row.confirmationDate).format("DD/MM/YYYY") : "NO",
      sortable: true,
      width: "105px",
    },
    {
      name: 'Validado',
      selector: row => row.validationDate ? new Date(row.validationDate) : null,
      format: row => row.validationDate ? moment(row.validationDate).format("DD/MM/YYYY") : "NO",
      sortable: true,
      width: "105px",
    },
    {
      name: 'Atendido Por',
      selector: row => row.atendidoPor,
      sortable: true,
      width: "140px",
    },
    {
      name: 'Monto',
      selector: row => formatToCLP(row.monto ?? 0),
      sortable: true,
      width: "110px",
    },
    {
      name: 'Creado',
      selector: row => row.createAt ? new Date(row.createAt) : null,
      format: row => moment(row.createAt).format("DD/MM/YYYY"),
      sortable: true,
      width: "105px",
    },
    {
      name: 'Estado',
      selector: row => row.statusContract,
      sortable: true,
      width: "182px",
    }
  ];

  // const HandleOpenCtto = async (row) => {
  //     navigate('/TabularPageV2', { state: { customerInterviewId: row.customerInterviewId } })
  // }

  const HandleOpenCtto = (row) => {
    const id = row.customerInterviewId;

    // Guardar en sessionStorage
    sessionStorage.setItem("customerInterviewId", id);

    // Navegar
    navigate('/ContratoPage', { state: { customerInterviewId: id } });
  }

  const handleChange = (e) => {

    const { name, value, type, checked } = e.target;

    const exclusives = {
      Validado: "NoValidado",
      NoValidado: "Validado",
      Confirmado: "NoConfirmado",
      NoConfirmado: "Confirmado",
    };

    setSearchCriteria(prevState => {
      const updated = {
        ...prevState,
        [name]: type === "checkbox" ? (checked ? true : null) : value
      };

      const exclusiveField = exclusives[name];
      if (exclusiveField) {
        updated[exclusiveField] = null;
      }

      return updated;
    });
  };

  // const handleSearch = async (e) => {

  //  console.log("Borrando variable de sesion customerInterviewId en Buscar  Contrato");

  //     sessionStorage.removeItem("customerInterviewId");

  //     e.preventDefault();
  //     dispatch(resetTabState());
  //     setLoading(true);
  //     // Simulación de búsqueda (reemplazar con la llamada real a la API)
  //     var auxForm = searchCriteria
  //     for (var propName in auxForm)
  //         if (auxForm[propName] === null || auxForm[propName] === undefined || auxForm[propName] === "") delete auxForm[propName]

  //     if (myAccount)
  //         auxForm["AtendidoPor"] = myAccount.get('identifier')


  //     await setTimeout(async () => {
  //         const contratos = await LobService.getSearchInterviewV2(auxForm);
  //         setFilteredItems(contratos);
  //         setLoading(false);
  //     }, 300);
  // };

  const handleSearch = async (e) => {
    e.preventDefault();

    // Limpia entrevista previa
    sessionStorage.removeItem("customerInterviewId");

    dispatch(resetTabState());
    setLoading(true);     // spinner general (tabla)
    setSearching(true);   // reloj en botón

    try {
      let auxForm = { ...searchCriteria };
      Object.keys(auxForm).forEach((k) => {
        if (auxForm[k] === null || auxForm[k] === undefined || auxForm[k] === "") {
          delete auxForm[k];
        }
      });

      if (myAccount) auxForm["AtendidoPor"] = myAccount.get('identifier');

      // (opcional) pequeño delay “cosmético”
      await new Promise((r) => setTimeout(r, 300));

      const contratos = await LobService.getSearchInterviewV2(auxForm);
      setFilteredItems(contratos);
    } catch (err) {
      console.error('Error al buscar contratos:', err);
      // Si quieres, aquí puedes mostrar un Swal de error
    } finally {
      setLoading(false);
      setSearching(false); // ← vuelve el icono del botón a la lupa
    }
  };


  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div>
        {/* Componente opcional para incluir filtros adicionales o botones */}
      </div>
    );
  }, []);

  const customStyles = {
    table: {
      style: {
        minWidth: 'auto',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#F2F2F7',
        borderBottom: 'none',
        window: 'auto',
      },
    },
    headCells: {
      style: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#86868B',
        textTransform: 'uppercase',
      },
    },
    cells: {
      style: {
        fontSize: '14px',
        color: '#1D1D1F',
      },
    },
  };

  useEffect(() => {
    dispatch(setCargaDatos())
  }, [])

  const exportToExcel = async () => {

    var auxForm = searchCriteria
    for (var propName in auxForm)
      if (auxForm[propName] === null || auxForm[propName] === undefined || auxForm[propName] === "") delete auxForm[propName]

    if (myAccount)
      auxForm["AtendidoPor"] = myAccount.get('identifier')

    const contratos = await LobService.getSearchInterviewExcelV2(auxForm);

    console.log(contratos)
    const filteredData = contratos.map(item => ({
      'Cliente': item.name,
      'Rut': item.identifier,
      'Cod Ctto': item.codCtto,
      'Linea Negocio': (item.lineOfBusiness ? item.lineOfBusiness.split(' ').slice(1).join(' ') : ''),
      'Firmado': item.confirmationDate ? moment(item.confirmationDate).format("DD/MM/YYYY") : 'NO',
      'Validado': item.validationDate ? moment(item.validationDate).format("DD/MM/YYYY") : 'NO',
      'Atendido Por': item.atendidoPor,
      'Fono Defendido': item.fonoDefendido ?? 'no definido',
      'Nombre Pagador': item.nombrePagador ?? 'no definido',
      'Fono Pagador': item.fonoPagador ?? 'no definido',
      'email': item.email ?? 'no definido',
      'emailPagador': item.emailPagador ?? 'no definido',
      'Monto': item.monto ?? 0,
      '1er Vencimiento':item.fechaPrimerVencimiento ?? 'no definido',
      'Metodo Pago': item.metodoPago ?? 'no definido',
      'Servicio': item.servicio ?? 'no definido',
      'Numero Cuotas': item.numeroCuotas ?? 'no definido',
      'Valor Cuota': item.valorCuota ?? 'no definido',
      'Creado': moment(item.createAt).format("DD/MM/YYYY"),
    }));
    const worksheet = XLSX.utils.json_to_sheet(filteredData); // conviertes tu data
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    const file = new Blob([excelBuffer], { type: 'application/octet-stream' });

    saveAs(file, 'Contratos_' + (moment(new Date()).format("DD_MM_YYYY")) + '.xlsx');
  };

  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
        <Typography className='mb-4' variant="h5" gutterBottom>
          Búsqueda de Contratos
        </Typography>

        {/* === Formulario de búsqueda === */}
        <Box component="form" noValidate autoComplete="off" onSubmit={handleSearch}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="Desde"
                label="Fecha Inicio"
                name="Desde"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={searchCriteria.Desde}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="Hasta"
                label="Fecha Fin"
                name="Hasta"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={searchCriteria.Hasta}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="LineNegocio-label">Línea de Negocios</InputLabel>
                <Select
                  labelId="LineNegocio-label"
                  id="LineNegocio"
                  name="LineNegocio"
                  value={searchCriteria.LineNegocio}
                  onChange={handleChange}
                >
                  <MenuItem value=""><em>-- Selecciona una opción --</em></MenuItem>
                  {_GENERAL?.negocios?.map((negocio) => (
                    <MenuItem key={negocio.id} value={negocio.id}>{negocio.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                id="Identifier"
                label="RUT Defendido"
                name="Identifier"
                value={searchCriteria.Identifier}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCriteria.Confirmado || false}
                    onChange={handleChange}
                    id="Confirmado"
                    name="Confirmado"
                    color="primary"
                  />
                }
                label="Contratos Confirmados"
              />
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCriteria.NoConfirmado || false}
                    onChange={handleChange}
                    id="NoConfirmado"
                    name="NoConfirmado"
                    color="primary"
                  />
                }
                label="Contratos No Confirmados"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCriteria.Validado || false}
                    onChange={handleChange}
                    id="Validado"
                    name="Validado"
                    color="primary"
                  />
                }
                label="Contratos Validados"
              />
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCriteria.NoValidado || false}
                    onChange={handleChange}
                    id="NoValidado"
                    name="NoValidado"
                    color="primary"
                  />
                }
                label="Contratos No Validados"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCriteria.Cancelado || false}
                    onChange={handleChange}
                    id="Cancelado"
                    name="Cancelado"
                    color="primary"
                  />
                }
                label="Incluir Cancelados"
              />
              <br />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={searchCriteria.Finiquitado || false}
                    onChange={handleChange}
                    id="Finiquitado"
                    name="Finiquitado"
                    color="primary"
                  />
                }
                label="Incluir Finiquitados"
              />
            </Grid>
          </Grid>

          <Box sx={{ mt: 1, display: 'flex', justifyContent: 'right', gap: 1 }}>
            <Button
              variant="contained"
              type="submit"
              size="large"
              startIcon={searching ? <HourglassTopTwoToneIcon /> : <ManageSearchIcon />}
              disabled={loading || searching}
            >
              {searching ? 'Buscando…' : 'Buscar'}
            </Button>

            <Button
              variant="contained"
              onClick={exportToExcel}
              disabled={!filteredItems?.length || searching}
            >
              Descargar Excel
            </Button>

          </Box>
        </Box>
      </Paper>

      {/* === Resultados agrupados por línea de negocio === */}
      <Paper className="apple-card" sx={{ p: 2, mt: 2 }}>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <Typography variant="body1">Cargando…</Typography>
          </Box>
        )}

        {!loading && (!filteredItems || filteredItems.length === 0) && (
          <Typography sx={{ p: 2 }}>No hay resultados para los criterios seleccionados.</Typography>
        )}

        {!loading && filteredItems?.length > 0 && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {(_GENERAL?.negocios ?? []).map((negocio) => {
              // agrupar por id si viene; si no, intentar por nombre dentro de lineOfBusiness
              const contratosNegocio = filteredItems.filter((item) => {
                const idItem =
                  item.lineOfBusinessId ??
                  item.lineId ??
                  item.lineaNegocioId ??
                  item.idLineaNegocio ??
                  null;

                if (idItem !== null && idItem !== undefined) {
                  return Number(idItem) === Number(negocio.id);
                }

                const nameItem = (item.lineOfBusiness || '').toLowerCase();
                return nameItem.includes((negocio.name || '').toLowerCase());
              });

              if (contratosNegocio.length === 0) return null;

              return (
                <Paper key={negocio.id} sx={{ p: 2 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                      {negocio.name}
                    </Typography>
                    <Typography variant="body2">
                      {contratosNegocio.length} contrato(s)
                    </Typography>
                  </Box>

                  <DataTable
                    columns={columns}
                    data={contratosNegocio}
                    progressPending={loading}
                    pagination
                    paginationPerPage={20}
                    paginationRowsPerPageOptions={[20, 30, 50, 100, 200]}
                    customStyles={customStyles}
                    noDataComponent="No hay contratos para este negocio"
                  />
                </Paper>
              );
            })}
          </Box>
        )}
      </Paper>

      <footer style={{ textAlign: 'left', marginTop: '20px' }}>
        <p>© {new Date().getFullYear()} Generador de Contratos v2.0.1. Todos los derechos reservados Grupo Defensa. Desarrollado por el area de Tecnología</p>
      </footer>
    </Container>
  );

};

export default ContractSearchPage;
